import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../services/auth.service';
import { CommonService } from '../services/common.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})
export class RegisterComponent implements OnInit {

  registerForm : FormGroup
  error = false
  successMailSent = false
  errorMessage = ''
  mailSentMessage = ''
  showPixel = false
  referrer

  constructor(private fb : FormBuilder, private authService : AuthService, private common : CommonService, private router : Router, private query : ActivatedRoute) { }

  ngOnInit(): void {
    
    this.query.queryParams.subscribe((params : any) => {
      this.referrer = params.referrer
    })

    this.registerForm = this.fb.group({
      username: ["", [Validators.required]],
      email: ["", [Validators.email, Validators.required]],
      password: ["", [Validators.required]],
      referrer: [this.referrer ? this.referrer : "campaign_001"]
    })
    this.showPixel = false
  }

  register(){
    this.common.showLoader()
    console.log(this.registerForm.value)
    this.authService.Register(this.registerForm.value).subscribe((res:any)=>{
      this.common.hideLoader()
      if(res.user){
        this.registerForm.reset()
        this.error = false
        this.errorMessage = ''
        this.successMailSent = true
        this.mailSentMessage = 'A verification mail has been sent to your email address, kindly click on the link to verify your account.'
        this.showPixel = true
      }
      else{
        console.log(res.message[0].messages[0].message)
      }
    }, (err:any)=>{
      this.common.hideLoader()
      this.error = true
      this.errorMessage = err.error.message[0].messages[0].message
      console.log(err.error.message[0].messages[0].message)
    })
  }

  clearError(){
    this.errorMessage = ''
    this.error = false
  }

  get formControl() {
    return this.registerForm.controls;
  }

}
